import WizardProfileService from '../../services/wizardprofile.service';
/*
    private Long id;
    private String fieldName;
    private String profileName;
    private String mfUsersGUID;
    private String profileContent;
    private Boolean published;
 */
const GRID_PROFILE_FIELDNAME = "GRID_PROFILE";

const state = {
    wizardProfiles: [],
    dialogVisible: false,
    currentProfile: null,
    activeProfile: null,
    activeProfileFields: []
};

const mutations = {
    setProfiles(state, profileList) {
        state.wizardProfiles = profileList;
    },
    addProfile(state, profile) {
        state.wizardProfiles.push(profile);
    },
    toggle(state, visible) {
        state.dialogVisible = visible
    },
    deleteProfile(context, index) {
        state.wizardProfiles = state.wizardProfiles.filter(value => value.id !== index);
    },
    loadProfile1: (state, obj) => {
        state.currentProfile = obj
    },
    updateProfile(context, profile) {
        let oldprofile = state.wizardProfiles.filter(value => value.id === profile.id)[0];
        oldprofile.profileName = profile.profileName;
        oldprofile.profileContent = profile.profileContent
    },
    publishProfile(state, profileId) {
        let profile = state.wizardProfiles.filter(value => value.id === profileId)[0];
        profile.published = true;
    },
    dePublishProfile(state, profileId) {
        let profile = state.wizardProfiles.filter(value => value.id === profileId)[0];
        profile.published = false;
    },
    setActiveProfile(state, profile) {
        state.activeProfile = profile;

        let fields = JSON.parse(profile.profileContent)[0];
        for (let field of fields) {
            if (!(field.fieldName === 'originalTitle' || field.fieldName === 'costUnitNumber')) {
                // field.fieldName = 'dynamicFields_' + field.fieldName;
                field['fieldLabel'] = field.label;
            }
        }
        state.activeProfileFields = fields;
    }
};

const getters = {
    getCurrentProfile: (state) => {
        return state.currentProfile
    },
    isDialogVisible: (state) => {
        return state.dialogVisible
    },
    profileCount: (state) => {
        return state.wizardProfiles.length;
    },
    getProfiles: (state) => {
        return state.wizardProfiles;
    },
    getActiveProfile: (state) => {
        return state.activeProfile;
    },
    getActiveProfileFields: (state) => {
        return state.activeProfileFields;
    }
}

const actions = {
    deleteProfile(context, index) {
        WizardProfileService.deleteProfile(index).then(() => {
            context.commit('deleteProfile', index);
        })
    },
    showDialog(context) {
        context.commit('toggle', true)
    },
    closeDialog(context) {
        context.commit('toggle', false)
        state.currentProfile = null
    },
    addProfile(context, profile) {
        if (!Object.prototype.hasOwnProperty.call(profile, "id")) {
            return WizardProfileService.saveProfile(profile).then(r => {
                let savedProfile = r.data;
                context.commit('addProfile', savedProfile);
                return savedProfile;
            })
        } else {
            return WizardProfileService.updateProfile(profile).then(() => {
                context.commit('updateProfile', profile);
            })
        }
    },
    loadGridProfiles(context) {
        return new Promise((resolve) => {
            WizardProfileService.loadProfilesForField(GRID_PROFILE_FIELDNAME).then(r => {
                context.commit('setProfiles', r.data);

                for (let profile of r.data) {
                    if (profile.defaultProfile === true) {
                        context.commit('setActiveProfile', profile);
                        break;
                    }
                }
                resolve();
            })
        })
    },
    loadCurrentProfile(context, obj) {
        context.commit('loadProfile1', obj)
    },
    publishProfile(context, profileId) {
        WizardProfileService.publishProfile(profileId).then(() => {
            context.commit('publishProfile', profileId);
        })
    },
    dePublishProfile(context, profileId) {
        WizardProfileService.dePublishProfile(profileId).then(() => {
            context.commit('dePublishProfile', profileId);
        })
    },
    setActiveProfile(context, profile) {
        context.commit('setActiveProfile', profile);
    },
    setDefault(context, profileId) {
        WizardProfileService.setDefault(profileId).then(() => {
            return context.dispatch("loadGridProfiles");
        })
    }


}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
